/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  makeStyles,
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import Icon from '@mdi/react'
import { mdiPencilOutline, mdiPlus, mdiTrashCanOutline } from '@mdi/js'

import colors from '../../../../../assets/colors'
import filterStylesComponents from '../../../../../assets/filterComponentsStyles'
import BasePopUp from '../../../../../components/hooks/BasePopUp'
import { SNACKBAR } from '../../../../main/MainActions'

import EnquadramentoFormModal from './FormModal'

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
  },
  subTitle: {
    flex: 1,
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
  },
  emptyRow: {
    color: colors.graylight,
    fontSize: '13px',
    textAlign: 'center',
  },
})

const Enquadramentos = ({
  title = 'Enquadramentos tributários',
  fields = [],
  indexFn,
  storeFn,
  updateFn,
  destroyFn,
}) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const styles = filterStylesComponents()

  const [rows, setRows] = useState([])
  const [open, setOpen] = useState(false)
  const [editing, setEditing] = useState(null)
  const [deleting, setDeleting] = useState(false)
  const [deleteTarget, setDeleteTarget] = useState(null)

  const fetchList = async () => {
    try {
      const resp = await indexFn()
      setRows(resp?.data || [])
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    fetchList()
  }, [])

  const handleOpenCreate = () => {
    setEditing(null)
    setOpen(true)
  }

  const handleOpenEdit = row => {
    setEditing(row)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setEditing(null)
  }

  const handleDelete = async () => {
    if (!deleteTarget?.id) return
    setDeleting(true)

    try {
      await destroyFn(deleteTarget.id)

      dispatch({
        type: SNACKBAR.SOFTSUCCESS,
        success: { message: 'Sucesso!' },
      })

      setDeleteTarget(null)
      await fetchList()
    } catch (err) {
      dispatch({
        type: SNACKBAR.HARDFAIL,
        error: { message: 'Erro ao excluir enquadramento!' },
      })
    } finally {
      setDeleting(false)
    }
  }

  const renderCell = (field, row) => {
    const value = row?.[field.name]
    if (value === null || value === undefined || value === '') return '-'

    if (field.type === 'select') {
      const option = field.options?.find(o => o.value == value)
      return option?.label ?? value
    }

    if (field.type === 'percentage') return `${value}%`

    return value
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box className={classes.header}>
          <Box className={classes.subTitle}>{title}</Box>
          <Button className={styles.btnAdd} onClick={handleOpenCreate}>
            <Icon path={mdiPlus} size={0.8} />
            Novo
          </Button>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {fields.map(field => (
                <TableCell key={field.name}>{field.label}</TableCell>
              ))}
              <TableCell align="right">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={fields.length + 1}
                  className={classes.emptyRow}
                >
                  Nenhum enquadramento cadastrado.
                </TableCell>
              </TableRow>
            )}

            {rows.map(row => (
              <TableRow key={row.id}>
                {fields.map(field => (
                  <TableCell key={field.name}>
                    {renderCell(field, row)}
                  </TableCell>
                ))}
                <TableCell align="right">
                  <Tooltip title="Editar">
                    <IconButton
                      size="small"
                      onClick={() => handleOpenEdit(row)}
                    >
                      <Icon
                        path={mdiPencilOutline}
                        size={0.8}
                        color={colors.primary}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Excluir">
                    <IconButton
                      size="small"
                      onClick={() => setDeleteTarget(row)}
                    >
                      <Icon
                        path={mdiTrashCanOutline}
                        size={0.8}
                        color={colors.error}
                      />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Grid>

      <EnquadramentoFormModal
        open={open}
        onClose={handleClose}
        fields={fields}
        editing={editing}
        storeFn={storeFn}
        updateFn={updateFn}
        onSaved={fetchList}
      />

      <BasePopUp
        open={!!deleteTarget}
        handleOpen={() => !deleting && setDeleteTarget(null)}
        type="info"
        title="Excluir enquadramento"
        message={`Deseja realmente excluir o enquadramento${
          deleteTarget?.nome ? ` "${deleteTarget.nome}"` : ''
        }?`}
        onConfirm={handleDelete}
      />
    </Grid>
  )
}

export default Enquadramentos
